module.exports = __webpack_public_path__ + "img/w-b-c-logo.fbcca8cb.jpg";